export default __webpack_public_path__ + "static/media/fb-clone.7b7cb341.png";